import React from 'react';

const ExampleFormulas = ({ onSelectExample }) => {
  const examples = [
    { name: "Simple 3-variable formula", formula: "(A or ~B) and (~A or C) and (B)" },
    { name: "Classic satisfiability example", formula: "(x1 or x2) and (~x1 or x3) and (~x2 or ~x3)" },
    { name: "4-clause formula", formula: "(A or B or C) and (~A or ~B) and (~B or ~C) and (A or ~C)" },
    { name: "Unsatisfiable formula", formula: "(p or q) and (~p or q) and (p or ~q) and (~p or ~q)" },
    { name: "Simple 2-clause formula", formula: "(a or b or c) and (~a or ~b or ~c)" }
  ];
  return (
    <div className="bg-blue-50 border-2 border-blue-300 rounded-lg p-4">
      <h3 className="font-bold text-lg mb-3 text-blue-900">Example Formulas</h3>
      <div className="space-y-2">
        {examples.map((example, idx) => (
          <button key={idx} onClick={() => onSelectExample(example.formula)} className="w-full text-left p-3 bg-white hover:bg-blue-100 rounded-lg transition-colors border border-blue-200">
            <div className="font-semibold text-sm text-gray-700 mb-1">{example.name}</div>
            <div className="text-xs text-gray-600 font-mono">{example.formula}</div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ExampleFormulas;